var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysPix = function SvgSysPix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    clipPath: "url(#sysPix_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.868 22.173-3.566-3.566a3.87 3.87 0 0 0 2.26-1.11l3.475-3.475a.159.159 0 0 1 .214 0l3.46 3.46a3.871 3.871 0 0 0 2.031 1.075l-3.616 3.616a3.008 3.008 0 0 1-4.258 0ZM17.744 5.446c.21-.04.425-.062.641-.066l-.641.066Zm0 0L14.129 1.83l.353-.353-.353.353a3.01 3.01 0 0 0-4.257 0l-.353-.353.353.353-3.564 3.564a3.874 3.874 0 0 1 2.256 1.11l3.48 3.48a.145.145 0 0 0 .204 0l3.464-3.465h.001a3.872 3.872 0 0 1 2.03-1.074ZM22.17 9.876l.002-.001a3.01 3.01 0 0 1-.004 4.253l-2.475 2.475h-1.229a1.89 1.89 0 0 1-1.327-.55l-3.465-3.466-.008-.008a2.204 2.204 0 0 0-1.11-.57c.42-.082.811-.287 1.119-.594l3.465-3.465a1.89 1.89 0 0 1 1.328-.55H19.695l2.476 2.476Zm-11.556 1.54c.307.306.697.51 1.118.592a2.204 2.204 0 0 0-1.111.571l-.009.008-3.48 3.48a1.89 1.89 0 0 1-1.327.55H4.318l-.007.001-2.488-2.488a3.01 3.01 0 0 1 0-4.257l2.488-2.489h1.495c.497.002.974.2 1.327.55l3.48 3.48v.001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sysPix_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSysPix;